<template>
  <v-container>
    <v-row>
      <v-col :cols="9">
        <v-text-field label="Ticket Attachments Code" v-model="code" />
      </v-col>
      <v-col :cols="3">
        <v-btn dark block @click="getAttachments">Search</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-flex>
        <ul>
          <li
            v-for="attachment of attachments"
            v-bind:key="attachment.file_url"
          >
            <a
              v-bind:href="attachment.file_url"
              target="_blank"
              rel="noopener"
              >{{ attachment.file_name }}</a
            >
            ({{ getHumanReadableFileSize(attachment.file_size) }})
          </li>
        </ul>
      </v-flex>

      <v-dialog v-model="loading" fullscreen>
        <v-container fluid fill-height class="dialog">
          <v-layout justify-center align-center>
            <v-progress-circular
              indeterminate
              :size="120"
              :width="1"
              color="primary"
              >Uploading...</v-progress-circular
            >
          </v-layout>
        </v-container>
      </v-dialog>

      <v-dialog v-model="error" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Something went wrong...
          </v-card-title>

          <v-card-text class="pa-4">
            <v-icon>mdi-alert</v-icon>
            An error has occurred. Please refresh the page and try again.
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="error = false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="noAttachmentsFound" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            No attachments found!
          </v-card-title>

          <v-card-text class="pa-4">
            No attachments have been found for ticket attachments code
            {{ code }}.
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="noAttachmentsFound = false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import filesize from "filesize";

import { newtinMixin } from "@/mixins/newtinMixin.js";

export default {
  mixins: [newtinMixin],
  data: () => ({
    loading: false,
    error: false,
    noAttachmentsFound: false,
    code: "",
    attachments: []
  }),
  methods: {
    getHumanReadableFileSize: filesize,
    getAttachments: async function() {
      if (!this.code) {
        return;
      }

      const getAttachmentsUrl = `${this.getNewtinUrl(
        window.location.href
      )}/getAttachments.vjs?ATTACHMENTS_CODE=${this.code}`;

      this.loading = true;

      try {
        const response = await axios.get(getAttachmentsUrl);

        if (!Array.isArray(response.data)) {
          this.error = true;
        } else {
          this.attachments = response.data;

          if (this.attachments.length === 0) {
            this.noAttachmentsFound = true;
          }
        }
      } catch (lookupError) {
        this.error = true;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.v-btn {
  background-image: linear-gradient(to right, #2685f4, #3a3dd1) !important;
}
</style>
